/**
 * Route for `advertiser-dashboard-separate-persona`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserDashboardSeparatePersonaPage } from "../features/advertiser-dashboard-separate-persona/AdvertiserDashboardSeparatePersonaPage";

export const advertiserDashboardSeparatePersonaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-dashboard-separate-persona",
	component: AdvertiserDashboardSeparatePersonaPage,
});

export default advertiserDashboardSeparatePersonaRoute;
